// extracted by mini-css-extract-plugin
module.exports = {"departments":"td","departmentHeading":"ud","departmentSection":"vd","departmentName":"wd","departmentLink":"xd","expandIcon":"yd"};